/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 *
 * @internal
 */
export function isObjectLike(value) {
  return typeof value == 'object' && value !== null;
}
